import React, { FormEvent, useReducer, useState } from 'react';
import { Auth } from 'aws-amplify';
import Input from 'components/Inputs/TextInput';
import { useAlert } from 'components/message/AlertContext';
import lock from 'assets/icons/lock.svg';
import ellipsis from 'assets/icons/ellipsis.svg';
import { PasswordValidation } from 'views/Auth/components';
import { NButton } from '@innersource-nn/novoui-react';

type FormState = {
    code: string;
    newPassword: string;
    confirmPassword: string;
};

type FormAction = {
    key: 'code' | 'newPassword' | 'confirmPassword';
    value: string;
};

const DEFAULT_FORM = {
    code: '',
    newPassword: '',
    confirmPassword: '',
};

type Props = {
    username: string;
};

export default function ChangePasswordForm({ username }: Props) {
    const [formData, setFormData] = useReducer(
        (state: FormState, action: FormAction): FormState => {
            const newState: FormState = { ...state };
            newState[action.key] = action.value;
            return newState;
        },
        DEFAULT_FORM,
    );
    const [isPasswordValid, setIsPasswordValid] = useState(false);
    const [isFormTouched, setIsFormTouched] = useState(false);

    const { openAlert } = useAlert();
    const changePasswordHandler = (e: FormEvent) => {
        e.preventDefault();
        setIsFormTouched(true);

        if (isPasswordValid)
            Auth.forgotPasswordSubmit(
                username,
                formData.code,
                formData.newPassword,
            ).catch((e) => {
                openAlert({
                    message: e.message,
                    severity: 'alert',
                });
            });
        else
            openAlert({
                message: `Password is invalid`,
                severity: 'alert',
            });
    };

    return (
        <form className="flex flex-col w-full gap-y-8">
            <Input
                required
                placeholder="Code"
                value={formData.code}
                onChange={(e) => {
                    setFormData({
                        key: 'code',
                        value: e.target.value,
                    });
                }}
                className="w-full"
                icon={ellipsis}
            />
            <Input
                required
                placeholder="New password"
                value={formData.newPassword}
                onChange={(e) => {
                    setFormData({
                        key: 'newPassword',
                        value: e.target.value,
                    });
                }}
                className="w-full"
                icon={lock}
                type="password"
            />
            <Input
                required
                placeholder="Enter new password again"
                value={formData.confirmPassword}
                onChange={(e) => {
                    setFormData({
                        key: 'confirmPassword',
                        value: e.target.value,
                    });
                }}
                className="w-full"
                icon={lock}
                type="password"
            />
            <PasswordValidation
                password={formData.newPassword}
                confirmPassword={formData.confirmPassword}
                isFormTouched={isFormTouched}
                setIsPasswordValid={setIsPasswordValid}
            />
            <NButton
                variant="fill"
                onClick={changePasswordHandler}
                size="small"
            >
                Reset my password
            </NButton>
        </form>
    );
}
